import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import RadioButtonListField from "../../../components/Fields/RadioButtonListField";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import { useAuth } from "../../../contexts/authContext";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { ItemItemRevisionPopupProps, ItemPopupProps, UserPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface UserAttachmentGenerateModel {
    userId: number
    attachmentTypeId: number
    language: string
    documentOutputTypeId: number
    outputOptions: number
}

const GenerateAttachmentPopup: React.FC<UserPopupProps> = ({ show, onHide, userId }) => {
    const [title, setTitle] = useState<string>();
    const [serverErrors, setServerErrors] = useState<DataResult<UserAttachmentGenerateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const attachmentTypes = useSelectListOptions('api/v1/selectlist/UserGeneratableAttachmentTypes', '-- Select attachment type');
    const languages = useSelectListOptions('api/v1/selectlist/Languages', '-- Select language');
    const documentOutputTypes = useSelectListOptions('api/v1/selectlist/DocumentOutputTypes', '-- Select output type');
    const outputOptions = useSelectListOptions('api/v1/selectlist/DocumentOutputOptions');

    const { handleResult, handleException } = useNotifications();
    const { translate } = useTranslations();
    const { user } = useAuth();

    let language = 'en-GB';
    if (user)
        language = user.language;

    const [formData, setFormData] = useState<UserAttachmentGenerateModel>({
        userId: userId,
        attachmentTypeId: 0,
        language: language,
        documentOutputTypeId: 3,
        outputOptions: 1,
    });

    useEffect(() => {
        translate('Generate an attachment').then(translated => setTitle(translated));
    }, [userId]);

    function submit() {

        const url = `api/v1/UserAttachments/Generate?userId=${formData.userId}&attachmentTypeId=${formData.attachmentTypeId}&language=${formData.language}&documentOutputTypeId=${formData.documentOutputTypeId}&outputOptions=${formData.outputOptions}`
        DataService
            .getFile(url)
            .then(response => {
                console.log('response', response)
                if (response instanceof Blob) {
                    const url = window.URL.createObjectURL(response);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.type === 'image/jpeg' ? 'attachment.jpg' : 'attachment.pdf');
                    document.body.appendChild(link);
                    link.click();

                    if (onHide)
                        onHide();
                }
                else {
                    handleResult(response)
                }

            })
            .catch(e => handleException(e));
    }

    function onFieldChanged(name: string, value: string | File): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'attachmentTypeId', label: 'Attachment type', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'language', label: 'Language', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'documentOutputTypeId', label: 'Output type', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'outputOptions', label: 'Options', labelSize: 4, validationRules: [{ type: 'isRequired' }] },

        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SelectListField {...getFieldProps('attachmentTypeId')} options={attachmentTypes} />
                <SelectListField {...getFieldProps('language')} options={languages} />
                <SelectListField {...getFieldProps('documentOutputTypeId')} options={documentOutputTypes} />
                <RadioButtonListField {...getFieldProps('outputOptions')} layout='vertical' options={outputOptions} />
            </Modal.Body>
            <Modal.Footer>
                <SaveButton text={'Generate'} {...getSubmitButtonProps()} />
            </Modal.Footer>
        </Modal>
    );
}
export default GenerateAttachmentPopup;